<template>
    <div class="container-fluid mt-2 p-2">
        <h2>{{ modconfig.name }}</h2>
        <div v-for="item in modconfig.config.userconfigs" :key="item.storage_id" class="row mt-2">
            <div class="col">
                <div class="form-group">
                    <label>{{ item.name }}</label>
                    <div v-if="item.type=='choice'" class="input-group">
                        <select class="form-control" v-model="valueMap[item.storageId]">
                            <option v-for="c,index in choiceMap[item.storageId]" :key="index" :value="c.value">{{ c.label }}</option>
                        </select>
                        <div class="input-group-append">
                            <button @click="loadChoice(item.script)" v-if="item.script" class="btn btn-primary"><font-awesome-icon icon="redo"/></button>
                        </div>
                    </div>
                    <input v-else type="text" class="form-control" v-model="valueMap[item.storageId]"/>
                </div>
            </div>
            <div class="col">
                <div>
                    {{ item.documentation }}
                </div>
            </div>
            <hr/>
        </div>
    </div>
</template>

<script>
import config from '@/modules/config.js'
import scripttasks from '@/modules/scripttasks';

export default {
    name: 'ModuleUserConfig',
    props: ["modconfig"],
    data() { 
        return {
            choiceMap: {},
            valueMap: {},
            stateMap: {},
            configMap: {},
        }
    },
    mounted() {
        console.log('config',this.config);
        this.valueMap = {};
        this.choiceMap = {};
        this.loadChoices();
        for (var idx in this.modconfig.config.userconfigs) {
            var ucfg = this.modconfig.config.userconfigs[idx];
            this.configMap[ucfg.storageId] = ucfg;
            console.log('storageId:' + ucfg.storageId);
            if (ucfg.type == "choice" && ucfg.choices && ucfg.choices.length > 0) {
                this.choiceMap[ucfg.storageId] = ucfg.choices;
            }
        }
        this.loadValues();
    },
    methods: {
        saveValues() {
            // save values to db 
            for (var key in this.valueMap) {
                let val   = this.valueMap[key];
                let state = this.stateMap[key];
                let cfg   = this.configMap[key];

                if (cfg && val && (val !== state)) {
                    var entry = {"value":val,"map_id":this.modconfig.module_id + '.' + cfg.storageId,"htmlDoc":cfg.documentation,"module":true};
                    console.log('save value:',entry);
                    var self = this;
                    config.saveFirmConfig(this,entry,function(data) {
                        self.$bvToast.toast('Gespeicher: ' + cfg.name,{variant:'success',title:'Module Konfiguration'});
                        console.log(data);
                    });
                    console.log('done');
                }
            }
        },
        loadChoice(name) {
            console.log('Run Script:',name);
            var self = this;
            scripttasks.run(this,name,function(data) {
                console.log('got choice data:',data);
                var errFields = [];
                if (data.error) {
                    self.$bvToast.toast('Fehler bei Abfrage der Konfigurationswerte:' + data.error,{variant:'warning',title:'Modul Konfiguration'});
                } else {
                    for (var key in data) {
                        console.log('choice key check:',key);
                        var field = data[key];
                        if (field && field.error) {
                            errFields.push(key);
                        } else if (field && field.choices) {
                            console.log('put choices:',key,field.choices);
                            self.choiceMap[key] = field.choices;
                        }
                    }
                    if (errFields.length > 0) {
                        self.$bvToast.toast('Fehler bei Abfrage der Konfigurations-Auswahl:' + errFields.join(", "));
                    }
                    console.log("updated choices:",self.choiceMap);
                    self.$forceUpdate();
                }
            })
        },
        loadChoices() {
            var scripts = [];
            for (var idx in this.modconfig.config.userconfigs) {
                var ucfg = this.modconfig.config.userconfigs[idx];
                if (ucfg.type=="choice" && ucfg.script && ucfg.script !== '' && !(scripts.indexOf(ucfg.script) >= 0)) {
                    console.log('add script: ' + ucfg.storageId);
                    scripts.push(ucfg.script);
                }
            }
            for (idx in scripts) {
                this.loadChoice(scripts[idx]);
            }
        },
        loadValues() {
            var self = this;
            config.listFirmConfig(this,0,1000,-1,function(data) {
                console.log('loaded data: ',data);
                for (var i=0;i<data.length;i++) {
                    var entry = data[i];
                    self.valueMap[entry.map_id.substring(self.modconfig.module_id.length+1)] = entry.value;
                }
                console.log(self.valueMap);
                self.$forceUpdate();
            },this.modconfig.module_id); 
        }
    }
}
</script>